// import { TextButton } from "components/buttons/TextButton"
// import { Printer } from "iconsax-react"
// import { formatMoney } from "utils"

import { Button } from "components/buttons/Button"
import { P1 } from "components/typography/P1"
import { P2 } from "components/typography/P2"
import { Arrow, More, Trash } from "iconsax-react"
import { useState } from "react"

type TableProps = {
  cols: number
  headers: (string | JSX.Element)[]
  rows: { selected?: boolean; data: (string | JSX.Element)[] }[]
  bordered?: boolean
  altRowColor?: boolean
  hoverable?: boolean
}

export const TableHeader: React.FC<{
  children: string | JSX.Element | JSX.Element[]
}> = (props) => {
  return (
    <P1 className="text-sec400 font-kumbh font-semibold">{props.children}</P1>
  )
}

export const TableData: React.FC<{
  children: number | string | JSX.Element | JSX.Element[]
}> = (props) => {
  return (
    <P2 className="text-grey900 font-kumbh font-semibold line-clamp-1">
      {props.children}
    </P2>
  )
}

export const TableMenuAction: React.FC<{
  //   children: JSX.Element | JSX.Element[]
}> = (props) => {
  const [menuOpen, toggleMenuOpen] = useState(false)
  return (
    <div className="relative">
      <div
        title="More"
        className="p-0 cursor-pointer"
        onClick={() => toggleMenuOpen(!menuOpen)}
      >
        <More className="w-7 text-primary500" />
      </div>
      <div
        className={`z-10 absolute h-auto ease-in-out transition-all right-0 w-[180px] -mt-6 ${
          menuOpen === true ? "block" : "hidden"
        }`}
      >
        <div className="bg-white drop-shadow-2xl rounded-lg py-4 px-2 w-full">
          <div className="w-full flex flex-col gap-2">
            <>
              <Button
                title="Restore"
                className="w-full"
                onClick={() => toggleMenuOpen(!menuOpen)}
              >
                <div className="w-full rounded-[4px] flex gap-2 items-center px-2 py-2 text-neutral500 hover:bg-primary600 hover:text-white">
                  <Arrow className="w-4" />
                  <P2>Restore</P2>
                </div>
              </Button>
              <Button
                title="Remove"
                className="w-full"
                onClick={() => toggleMenuOpen(!menuOpen)}
              >
                <div className="w-full rounded-[4px] flex gap-2 items-center px-2 py-2 text-danger300 hover:bg-danger300 hover:text-white">
                  <Trash className="w-4" />
                  <P2>Remove</P2>
                </div>
              </Button>
            </>
          </div>
        </div>
      </div>
    </div>
  )
}

export const Table: React.FC<TableProps> = ({
  cols,
  headers,
  rows,
  bordered,
  altRowColor,
  hoverable,
}) => {
  return (
    <div className="overflow-auto bg-white border border-grey300">
      <table className="h-auto w-full table table-auto pb-3 mt -1 mb -3">
        <thead className="table-header-group bg-white text-neutral700">
          <tr>
            {headers.map((header, index) => (
              <th
                key={index}
                align="center"
                className={`align-middle font-kumbh font-semibold ${
                  bordered === true && index < headers.length - 1
                    ? "border-r border-r-grey300"
                    : ""
                } py-4 px-3`}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white space-y-2.5">
          {rows.map((row, index) => (
            <>
              {bordered === true && (
                <tr>
                  <td colSpan={cols}>
                    <hr className="mx-auto my-1 border-accentGrey3 w-full" />
                  </td>
                </tr>
              )}
              <tr
                key={index}
                className={`${
                  hoverable === true ? "hover:bg-grey50 cursor-pointer" : ""
                } ${
                  row.selected === true
                    ? "bg-grey100"
                    : altRowColor === true
                    ? index % 2 > 0
                      ? "bg-white"
                      : "bg-grey50"
                    : "bg-white"
                }`}
              >
                {row.data.map((td, index) => (
                  <td
                    key={index}
                    align="center"
                    className={`align-middle text-sm font-medium text-grey900 ${
                      bordered === true && index < row.data.length - 1
                        ? "border-r border-r-grey300"
                        : ""
                    } py-5 px-3`}
                  >
                    {td}
                  </td>
                ))}
              </tr>
            </>
          ))}
        </tbody>
      </table>
    </div>
  )
}
